import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { useInstance, onUnmounted } from 'intact-vue-next';
import { SHOW, HIDE } from './constants';
// only close the top dialog when press ESC
var dialogs = [];
var escClose = function escClose(e) {
  var dialog = dialogs[dialogs.length - 1];
  if (e.keyCode === 27 && dialog.get('escClosable')) {
    dialog.terminate();
  }
};
export function useEscClosable() {
  var instance = useInstance();
  instance.on(SHOW, function () {
    if (!dialogs.length) {
      document.addEventListener('keydown', escClose);
    }
    dialogs.push(instance);
  });
  function onHide() {
    // the order is uncertain in different frameworks
    var index = dialogs.indexOf(instance);
    // const dialog = dialogs.pop();
    // const dialog = dialogs.shift();
    if (process.env.NODE_ENV !== 'production') {
      // if (dialog !== instance) {
      if (index === -1) {
        throw new Error('The dialog has handled hide callback. Maybe it is a bug of KPC');
      }
    }
    _spliceInstanceProperty(dialogs).call(dialogs, index, 1);
    if (!dialogs.length) {
      document.removeEventListener('keydown', escClose);
    }
  }
  instance.on(HIDE, onHide);
  onUnmounted(function () {
    if (instance.get('value')) {
      onHide();
    }
  });
}